import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import fastDeepEqual from 'fast-deep-equal';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter, find } from 'rxjs/operators';
import { GetOrganizationDto } from '../../dtos/getOrganizationDto.interface';
import { OrganizationProvider } from '../../provider/organisation.provider';
@UntilDestroy()
@Component({
    selector: 'aumico-organization-general-information-page',
    templateUrl: './organization-general-information.page.html',
    styleUrls: ['./organization-general-information.page.scss'],
})
export class OrganizationGeneralInformationPage implements OnInit {
    organizationProfile: GetOrganizationDto | undefined;
    private modifiedOrganizationProfile: GetOrganizationDto | null = null;
    private dataChanges$ = new BehaviorSubject<GetOrganizationDto | null>(null);

    @Input() countryOptions: INameId[];
    @Input() proceedButtonEvent$: Observable<void>;
    @Input() save$: Observable<void>;

    @Output() organizationProfileChanges = new EventEmitter<GetOrganizationDto>();
    @Output() initialOrganizationProfile = new EventEmitter<GetOrganizationDto>();

    constructor(private organizationProvider: OrganizationProvider) {}

    ngOnInit(): void {
        this.getUserOrganizationProfile();

        this.dataChanges$
            .pipe(
                filter((organizationProfileChanges) => organizationProfileChanges != null),
                distinctUntilChanged((previous, current) => fastDeepEqual(previous, current)),
                untilDestroyed(this),
            )
            .subscribe((organizationProfileChanges) =>
                this.organizationProfileChanges.emit(organizationProfileChanges as GetOrganizationDto),
            );

        this.proceedButtonEvent$.pipe(untilDestroyed(this)).subscribe(() => this.updateOrganizationProfile());

        this.save$.pipe(untilDestroyed(this)).subscribe(() => this.updateOrganizationProfile());
    }

    modifyUserOrganizationProfileGeneralInformation(organizationProfile: GetOrganizationDto) {
        this.modifiedOrganizationProfile = { ...this.modifiedOrganizationProfile, ...organizationProfile };

        this.dataChanges$.next(this.modifiedOrganizationProfile);
    }

    private getUserOrganizationProfile(): void {
        this.organizationProvider
            .getCurrentOrganization$()
            .pipe(find((organizationProfile: GetOrganizationDto) => organizationProfile != null))
            .subscribe(this.handleGetUserOrganizationProfileResponse.bind(this));
    }

    private handleGetUserOrganizationProfileResponse(organizationProfile: GetOrganizationDto): void {
        this.initialOrganizationProfile.emit(organizationProfile);

        this.organizationProfile = organizationProfile;
        this.modifiedOrganizationProfile = { ...organizationProfile };
        this.dataChanges$.next(this.modifiedOrganizationProfile);
    }

    private updateOrganizationProfile() {
        if (this.modifiedOrganizationProfile == null) {
            throw new Error('modifiedOrganizationProfile is null');
        }
        this.organizationProvider.dispatchUpdateCurrentOrganization(this.modifiedOrganizationProfile);
    }
}
